"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#07080a",
          color: "#ffffff",
          fontFamily: "system-ui, sans-serif",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: 12,
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            color: "#ff6b4a",
          }}
        >
          Chyba
        </p>
        <h1 style={{ marginTop: 16, fontSize: 28, fontWeight: 600 }}>
          Něco se pokazilo
        </h1>
        <p style={{ marginTop: 12, maxWidth: 420, color: "#9c9c9d", lineHeight: 1.6 }}>
          Omlouváme se, stránku se nepodařilo načíst. Zkuste to prosím znovu.
          {error.digest ? ` (kód: ${error.digest})` : ""}
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            marginTop: 28,
            padding: "12px 24px",
            borderRadius: 12,
            border: "none",
            background: "#ff6b4a",
            color: "#ffffff",
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Zkusit znovu
        </button>
      </body>
    </html>
  );
}
